import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import appData from './modules/appData';
import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';

Vue.use(Vuex);

localForage.config({
  driver: localForage.INDEXEDDB,
  name: 'localState',
  version: 1.0,
});

// For remove old cache data
localForage.clear();

const vuexLocal = new VuexPersistence({
  storage: localForage as any,
  asyncStorage: true,
});

export default new Vuex.Store({
  modules: {
    appData,
  },
  plugins: [vuexLocal.plugin],
  //plugins: [createPersistedState({ storage: window.sessionStorage })],
});